import TokenConfirmationCheck from '@app/2Factor/TokenConfirmationCheck'

export function install(Vue) {
  Vue.component(TokenConfirmationCheck.name, TokenConfirmationCheck)
}

export default { install }
